
const suffixMultipliers: Record<string, number> = {
    K: 1_000,
    M: 1_000_000,
    B: 1_000_000_000,
};

export function convertUnitToValue(value: number | string, suffix: string): number {
    const numericValue = +value || 0;
    const multiplier = suffixMultipliers[suffix] || 1;
    return (numericValue * multiplier);
}

export function convertValueToUnit(value: number, suffix: string): number {
    const multiplier = suffixMultipliers[suffix] || 1;
    return value / multiplier;
}